import React, { ReactNode } from 'react';
import { NotificationManager } from './reactToastify';
import ToastMessage from './showToast';
import { NotificationType } from './types';

const showToast = (type: NotificationType, message?: string | ReactNode, actionRequired = false) => {
  const charLimit = 120;
  const isLongPlainTextMessage = typeof message === 'string' && message.length > charLimit;
  const timeout = actionRequired || isLongPlainTextMessage ? 0 : 5000;

  const displayMessage = (msg: string | ReactNode) => ({ closeToast }: { closeToast: () => void }) => (
    <ToastMessage message={msg} type={type} closeToast={closeToast} />
  );

  switch (type) {
    case 'success':
      NotificationManager.success(displayMessage(message), '', timeout);
      break;
    case 'warning':
      NotificationManager.warning(displayMessage(message), '', timeout);
      break;
    case 'error':
      NotificationManager.error(displayMessage(message), '', timeout);
      break;
    case 'info':
    default:
      NotificationManager.info(displayMessage(message), '', timeout);
      break;
  }
};

export default showToast;
